import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { DialogApprovalsEquipmentsComponent } from './dialog-approvals-equipments.component';
import { TabApprovalsEquipmentsModule } from './tabs/approvals-equipments/tab-approvals-equipments.module';
import { TabApprovalsEquipmentsAttachmentsModule } from './tabs/attachments/tab-approvals-equipments-attachments.module';
import { TabApprovalsEquipmentsCustomFieldsModule } from './tabs/custom-fields/tab-approvals-equipments-custom-fields.module';

import { DialogApprovalsEquipmentsApproveModule } from './../dialog-approvals-approve/dialog-approvals-approve.module';
import { DialogApprovalsEquipmentsRejectModule } from './../dialog-approvals-reject/dialog-approvals-reject.module';

@NgModule({
    entryComponents: [
        DialogApprovalsEquipmentsComponent
    ],
    declarations: [
        DialogApprovalsEquipmentsComponent
    ],
    imports: [
        TranslateModule,

        FuseSharedModule,
        MatIconModule,
        MatTabsModule,
        MatButtonModule,
        MatToolbarModule,

        TabApprovalsEquipmentsModule,
        TabApprovalsEquipmentsCustomFieldsModule,
        TabApprovalsEquipmentsAttachmentsModule,

        DialogApprovalsEquipmentsApproveModule,
        DialogApprovalsEquipmentsRejectModule
    ],
    exports: [
        DialogApprovalsEquipmentsComponent
    ]
})
export class DialogApprovalsEquipmentsModule {
}
